import React, { FC } from 'react';
import { buildCollectionTiles } from '../ItvRowCollection/utils/collectionTiles';
import { RowCollectionLayout } from '../ItvRowCollection/layouts/types';
import { PlatformPromos } from '../../../hooks/useFetchPlatformPromos/types';
import { mockImages } from '../ItvRowCollection/mocks';
import { GetItvCollectionBySlugQuery } from '../../../libs/graphql/betzoneDirectusAPI/queries/__generated__/getItvCollectionBySlug.query.generated';
import './ItvViewAll.scss';

type ViewAllCollectionData = GetItvCollectionBySlugQuery['collection'][0];

interface ItvViewAllProps {
  collection: ViewAllCollectionData;
  onBack: () => void;
  platformPromos?: PlatformPromos;
}

const getRandomImages = (count = 50): string[] => {
  const available = [...mockImages];
  const result: string[] = [];

  while (result.length < count && available.length > 0) {
    const index = Math.floor(Math.random() * available.length);
    const [url] = available.splice(index, 1);

    if (url) result.push(url);
  }

  // If we need more images than available, repeat the pattern
  while (result.length < count) {
    result.push(mockImages[result.length % mockImages.length]);
  }

  return result;
};

export const ItvViewAll: FC<ItvViewAllProps> = ({ collection, onBack, platformPromos }) => {
  const title = collection.translations?.[0]?.title || 'View All';
  const fallbackImages = getRandomImages(collection.games?.length || 50);

  const tiles = buildCollectionTiles({
    collectionId: collection.id,
    collectionType: collection.type,
    layoutType: 'grid-5x5' as RowCollectionLayout, // 5 items per row grid layout
    games: collection.games,
    promotions: collection.promotions,
    fallbackImages,
    stubImageClassName: 'itv-view-all__item',
    platformPromos,
  });

  return (
    <div className="itv-view-all">
      <div className="itv-view-all__header">
        <h1 className="itv-view-all__title">{title}</h1>
        <p className="itv-view-all__back-text" onClick={onBack} aria-label="Back to lobby">
          Back to Lobby
        </p>
      </div>

      <div className="itv-view-all__grid">{tiles}</div>
    </div>
  );
};
